import React from "react";
import { Button, Grid, withStyles } from "@material-ui/core";
import Header from "./Header";
import constants from "../constants";
import Select from "../../../../../../common/StyledSelect";
import styles from "../../styles";

const localStyles = (theme) => ({
  disabledConfirmButton: {
    cursor: "not-allowed",
    pointerEvents: "all",
    color: theme.iconColor,
  },
  confirmButton: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    borderRadius: "2px",
    margin: "10 0 10 5",
    "&$disabledConfirmButton,&$disabledConfirmButton:hover": {
      color: theme.iconColor,
    },
  },
});

const MoveBills = ({
  classes,
  fromTrailersList,
  handleChange,
  errorInfo,
  movedToTrailerNumber,
  toTrailersList,
  selectedStopType,
  handleBillType,
  handleNextClick,
  isSectionDisabled,
}) => {
  const getActiveRoutesTrailer = () => {
    return fromTrailersList.find((trailer) => trailer.isActiveRoute);
  };

  return (
    <div
      className={`${classes.containerStyle} ${
        isSectionDisabled ? classes.sectionDisabled : null
      }`}
    >
      <div className={classes.sectionTitle}>Move Bills</div>
      <Grid container>
        <Grid item xs={6} className={classes.flexRow}>
          <Select
            value={
              getActiveRoutesTrailer()?.label ?? fromTrailersList[0]?.label
            }
            data={fromTrailersList}
            onChange={handleChange("fromTrailer")}
            rootClass={classes.selectRoot}
            textFieldProps={{
              id: "fromTrailersList",
              label: "From Trailer",
              variant: "outlined",
              helperText: errorInfo?.fromTrailer,
            }}
            isNotClearable
            error={Boolean(errorInfo?.fromTrailer)}
          />
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={6} className={classes.flexRow}>
          <Select
            value={movedToTrailerNumber?.label}
            data={toTrailersList}
            onChange={handleChange("movedToTrailerNumber")}
            rootClass={classes.selectRoot}
            textFieldProps={{
              id: "toTrailersList",
              label: "To Trailer",
              variant: "outlined",
              helperText: errorInfo?.movedToTrailerNumber,
            }}
            isNotClearable
            error={Boolean(errorInfo?.movedToTrailerNumber)}
          />
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Header label="SELECT BILLS" />
        </Grid>
        <Grid item xs={8} className={classes.flexRow}>
          <Select
            value={selectedStopType?.label}
            data={Object.values(constants.STOPS).map((billType) => ({
              label: billType,
              value: billType,
            }))}
            onChange={handleBillType}
            rootClass={classes.selectRoot}
            textFieldProps={{
              id: "selectedStopType",
              label: "Select Bill Type",
              variant: "outlined",
              helperText: errorInfo?.selectedStopType,
            }}
            isNotClearable
            error={Boolean(errorInfo?.selectedStopType)}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
      <div className={classes.actionButtons}>
        <Button
          color="primary"
          variant="contained"
          className={classes.confirmButton}
          onClick={handleNextClick}
          classes={{
            disabled: classes.disabledConfirmButton,
          }}
          disabled={isSectionDisabled}
        >
          MOVE BILLS
        </Button>
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  ...styles(theme),
  ...localStyles(theme),
}))(MoveBills);
